export default "__VITE_ASSET__DcEkCmKn__"